import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { http } from "../lib/api";
import Shop from "./Shop";
import Countdown from "../components/Countdown";

export default function CollectionPage() {
  const { slug } = useParams();
  const [col, setCol] = useState(null);
  const [notifyEmail, setNotifyEmail] = useState("");
  useEffect(() => { http.get(`/collections/${slug}`).then((r) => setCol(r.data)).catch(() => setCol(false)); }, [slug]);

  const scheduled = col?.effective_status === "scheduled";

  const notify = async (e) => {
    e.preventDefault();
    try { await http.post("/newsletter", { email: notifyEmail, source: `collection:${slug}` }); toast.success("We'll notify you at launch."); setNotifyEmail(""); }
    catch { toast.error("Could not sign up"); }
  };

  return (
    <div>
      <section className="relative h-[52vh] bg-zinc-950 overflow-hidden flex items-end">
        {col?.banner_image && <img src={col.banner_image} alt={col.name} className="absolute inset-0 w-full h-full object-cover opacity-75" />}
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
        <div className="relative p-6 sm:p-12 max-w-3xl">
          <p className="text-accent text-xs uppercase tracking-widest font-semibold mb-2">Collection</p>
          <h1 className="font-display text-5xl sm:text-8xl text-white uppercase tracking-tight leading-none">{col?.name || "Collection"}</h1>
          {col?.long_description && <p className="text-zinc-300 mt-4 max-w-lg text-sm">{col.long_description}</p>}
        </div>
      </section>

      {scheduled ? (
        <section className="max-w-xl mx-auto text-center py-24 px-4">
          <h2 className="font-display text-4xl text-white uppercase">Dropping Soon</h2>
          <p className="text-zinc-400 mt-3">Be first to know when {col.name} goes live.</p>
          {col.launch_date && <div className="flex justify-center mt-8"><Countdown target={col.launch_date} /></div>}
          <form onSubmit={notify} className="flex max-w-md mx-auto mt-6">
            <input type="email" required value={notifyEmail} onChange={(e) => setNotifyEmail(e.target.value)} placeholder="your@email.com"
              data-testid="collection-notify-input" className="flex-1 bg-zinc-900 border border-zinc-800 px-4 py-3.5 text-sm focus:border-accent-ss" />
            <button className="btn-accent px-6 text-sm font-bold uppercase tracking-widest" data-testid="collection-notify-btn">Notify Me</button>
          </form>
          <Link to="/shop" className="inline-block mt-8 text-xs text-zinc-500 uppercase tracking-widest border-b border-zinc-700">Shop available drops</Link>
        </section>
      ) : (
        <Shop key={slug} title="" fixedCollection={slug} hideFilters />
      )}
    </div>
  );
}
